import Nav from "./modules/nav";
import Modal from "./modules/modal.js";
import Tab from "./modules/tab.js";
import Carousel from "./modules/carousel.js";
import Header from "./modules/header.js";
import Common from "./modules/common.js";
import TabCarouselBind from "./modules/tab_carousel_bind.js";
import Slider from "./modules/slider.js";


//nav
const nav = new Nav();
nav.init();

//modal
const modal = new Modal();
modal.init();

//tab
const tab = new Tab();
tab.init();

// carousel
const carousel = new Carousel();
carousel.init();

// header
const header = new Header();
header.init();

// common
const common = new Common();
common.init();

// tabCarouselBind
const tabCarouselBind = new TabCarouselBind();
tabCarouselBind.init();

// slider
const slider = new Slider();
$(window).on('load resize', function () {
  slider.init();
})



// WEBPACK FOOTER //
// ./src/assets/js/script.js